import React, { useEffect }  from 'react'
import AOS from "aos";
import "aos/dist/aos.css"; 
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import img1 from '../assets/img/vi-1.png'
import img2 from '../assets/img/vi2.png'
import img3 from '../assets/img/vi-3.png'
import img4 from '../assets/img/vi-4.png'
import img5 from '../assets/img/vi-5.png'
import img6 from '../assets/img/vi-6.png'
const Video = () => {
     useEffect(() => {
        AOS.init({
          duration: 1000,   
          easing: "ease-in-out",       
        });
      }, []);
  return (
    <div>
        

    <div className="blog">
       {/* HERO SECTION */}
    <section
  className="about-hero"
  data-aos="fade-up"
>
  {/* BLURRED IMAGE LAYER */}
  <div className="hero-bg"></div>

  {/* CONTENT (NOT BLURRED) */}
  <div className="hero-content text-center text-white">
    <div className="container">
      <h1 className="fw-bold text-white">Latest Video</h1>
      <p className="mt-3">
        A leading national law firm delivering strategic, trusted legal solutions
      </p>
    </div>
  </div>
</section>
      <div className="container-fluid mt-4 px-5">
        {/* <div className="section-header">
          <h2>Latest Video</h2>
        </div> */}

        <div className="row blog-page">

          {/* Blog Item 1 */}
          <div className="col-lg-4 col-md-6 blog-item">
            <a
              href="https://www.youtube.com/watch?v=X2gKUDLMl3w"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={img1} alt="Blog 1" className="img-fluid" />
            </a>
            {/* <h3>Lorem ipsum dolor</h3> */}
            
            <p>
               Transfer Premium and Cultural Funds in Housing Cooperatives - Adv. Shreeprasad Parab
</p>
            <a
              className="btn"
              href="https://www.youtube.com/watch?v=X2gKUDLMl3w"
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch on YouTube <i className="bi bi-arrow-right"></i>
            </a>
          </div>

          {/* Blog Item 2 */}
          <div className="col-lg-4 col-md-6 blog-item">
            <a
              href="https://www.youtube.com/watch?v=PmQ_O_RKIJo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={img2} alt="Blog 2" className="img-fluid" />
            </a>
            {/* <h3>Lorem ipsum dolor</h3> */}
            
            <p>
              Supremacy of General Body Resolution against Provisions MCS Act and Bye-Laws.
            </p>
            <a
              className="btn"
              href="https://www.youtube.com/watch?v=PmQ_O_RKIJo"
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch on YouTube <i className="bi bi-arrow-right"></i>
            </a>
          </div>
  {/* Blog Item 1 */}
          <div className="col-lg-4 col-md-6 blog-item">
            <a
              href="https://www.youtube.com/watch?v=lMMN-MCqOZ8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={img3} alt="Blog 1" className="img-fluid" />
            </a>
            {/* <h3>Lorem ipsum dolor</h3> */}
            
            <p>
             Supremacy of General Body Resolution against Provisions MCS Act & Bye Laws
            </p>
            <a
              className="btn"
              href="https://www.youtube.com/watch?v=lMMN-MCqOZ8"
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch on YouTube <i className="bi bi-arrow-right"></i>
            </a>
          </div>

          {/* Blog Item 2 */}
          <div className="col-lg-4 col-md-6 blog-item">
            <a
              href="https://www.youtube.com/watch?v=funQKqX3kVM"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={img4} alt="Blog 2" className="img-fluid" />
            </a>
            {/* <h3>Lorem ipsum dolor</h3> */}
            {/* <div className="meta">
                  <i className="bi bi-list"></i>  <a href="#">Family Law</a>{" "}
             <i className="bi bi-calendar-event ms-3"></i> <p>01-Jan-2045</p>
            </div> */}
            <p>
             FLOOR SPACE INDEX BY ADV. SHREEPRASAD PARAB.
            </p>
            <a
              className="btn"
              href="https://www.youtube.com/watch?v=funQKqX3kVM"
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch on YouTube <i className="bi bi-arrow-right"></i>
            </a>
          </div>
  {/* Blog Item 1 */}
          <div className="col-lg-4 col-md-6 blog-item">
            <a
              href="https://www.youtube.com/watch?v=8ZdQCB-skJ0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={img5} alt="Blog 1" className="img-fluid" />
            </a>
            {/* <h3>Lorem ipsum dolor</h3> */}
          
            <p>
              Transfer of property through Gift Deed : Adv Shreeprasad Parab
            </p>
            <a
              className="btn"
              href="https://www.youtube.com/watch?v=8ZdQCB-skJ0"
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch on YouTube <i className="bi bi-arrow-right"></i>
            </a>
          </div>

          {/* Blog Item 2 */}
          <div className="col-lg-4 col-md-6 blog-item">
            <a
              href="https://www.youtube.com/watch?v=fSyxHNA3aFU"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={img6} alt="Blog 2" className="img-fluid" />
            </a>
            {/* <h3>Lorem ipsum dolor</h3> */}
           
            <p>
              Precautions during Sale Purchase of Re Sale Flats : Adv. Shreeprasad Parab
            </p>
            <a
              className="btn"
              href="https://www.youtube.com/watch?v=fSyxHNA3aFU"
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch on YouTube <i className="bi bi-arrow-right"></i>
            </a>
          </div>

        </div>
         </div>
    </div>
  
    </div>
  )
}

export default Video